<!--===============================
=            TODO LIST            =
================================-->
<template>
	<div>
		<v-row>
			<base-header>
				<div slot="page-header">Todo List</div>
			</base-header>
		</v-row>
		<v-row>
			<v-col class="col-12 col-md-12 col-sm-12">
				<base-card>
					<div slot="card-header">Todo List </div>
					<div slot="card-subheader">Aliquip dolore in amet adipisicing ullamco excepteur sit eu aute sunt
						sit. Anim labore mollit consequat duis. Nulla in incididunt velit ut ut.</div>
					<div slot="card-body">
						<todo-list list-name="My to-dos" />

					</div>
				</base-card>
			</v-col>
		</v-row>


	</div>

</template>
<script>
	import BaseCard from "../../components/Base/BaseCard.vue";
	import BaseHeader from "../../components/Base/BaseHeader.vue";
	import TodoList from "../../components/Apps/todo/TodoList.vue"
	export default {
		components: {
			BaseCard,
			BaseHeader,
			TodoList
		},
		methods: {
			alert() {
				alert('Hello, World!')
			},
		},
	}
</script>


<!--====  End of TODO LIST  ====-->